import { Box, Typography } from "@mui/material";

interface HistoryMetricCardProps {
    helper: string;
    label: string;
    sublabel?: string;
    value: string;
}

export default function HistoryMetricCard({ helper, label, sublabel, value }: HistoryMetricCardProps) {
    return (
        <Box
            sx={{
                p: 1.75,
                borderRadius: 3,
                border: "1px solid rgba(216, 225, 235, 0.9)",
                background: "linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(248, 250, 252, 0.96))",
                textAlign: "center",
            }}
        >
            <Typography variant="overline">{label}</Typography>
            {sublabel ? (
                <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.35, fontWeight: 700 }}>
                    {sublabel}
                </Typography>
            ) : null}
            <Typography variant="h5" sx={{ mt: sublabel ? 0.25 : 0.45 }}>{value}</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.7, lineHeight: 1.6 }}>
                {helper}
            </Typography>
        </Box>
    );
}
